export default __webpack_public_path__ + "static/media/Montserrat-Light.f0963fd9.ttf";